import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";

/**
 * Extracts and formats patient name from order data
 * @param data - The medical PA order data
 * @returns Formatted patient name
 */
export const getPatientName = (data: MedicalPaOrder): string => {
  return data?.demographics?.first_name + " " + data?.demographics?.last_name;
};

/**
 * Converts a Blob to a File object
 * @param blob - The blob to convert
 * @param fileName - The desired file name
 * @returns File object
 */
export const blobToFile = (blob: Blob, fileName: string): File => {
  return new File([blob], fileName, { type: blob.type });
};
